import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {
  Aangifte, AangifteBerekening,
  AangifteRapport, BokkzAlgDataService, Box1Berekening, IncomeTaxEntity, OpbouwEW, OpbouwInkomenBox1,
  SpecificatieEW
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService  } from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject, combineLatest} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-eigen-woning',
  templateUrl: './overzicht-eigen-woning.component.html',
  styleUrls: ['./overzicht-eigen-woning.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class OverzichtEigenWoningComponent implements OnInit, OnChanges {
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;

    @Input() aangifteRapport = {} as AangifteRapport;
    @Input() partnerRapport = {} as AangifteRapport;
    @Input() berekening = {} as AangifteBerekening;
    @Input() partnerBerekening = {} as AangifteBerekening;

    specEigenWoningFormGroup = this.fb.group<AangifteRapport>({});
    specEigenWoning = {} as AangifteRapport;
    berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});
    berekeningBox1 = {} as AangifteBerekening;

    constructor(  public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specEigenWoningFormGroup = this.fb.group<AangifteRapport>(({
            specificatieEW: this.fb.group<SpecificatieEW>(({
                opbouw: this.fb.group<OpbouwEW>(({
                    eigenWoningForfait: null as unknown as number,
                    belastDeelKapitaalverzekering: null as unknown as number,
                    eigenWoningRente: null as unknown as number,
                    erfpachtcanon: null as unknown as number,
                    personeelsvoordeel: null as unknown as number,
                    kostenEigenWoningSchuld: null as unknown as number,
                    renteRestschuldEigenWoning: null as unknown as number,
                    kostenRestschuldEigenWoning: null as unknown as number,
                    huurinkomstenEW: null as unknown as number,
                    aandeelInVoordeelEigenWoning: null as unknown as number,
                    aandeelInRenteEnKostenEigenWoning: null as unknown as number,
                    aandeelInSaldoEigenWoning: null as unknown as number,
                } as OpbouwEW))
            } as SpecificatieEW))
        } as AangifteRapport))
        this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                opbouwInkomen: this.fb.group<OpbouwInkomenBox1>(({
                    periodiekeUitkeringen: null as unknown as number,
                    saldoEigenWoning: null as unknown as number,
                    inkomstenUitEigenWoning: null as unknown as number,
                    aftrekWegensGeenOfGeringeEigenWoningSchuld: null as unknown as number,
                } as OpbouwInkomenBox1)),
            } as Box1Berekening)),
        } as AangifteBerekening))
    }

    public ngOnInit(): void {
        combineLatest([this.dataService.incomeTaxEntity, this.partner]).subscribe(
            ([incomeTaxEntity, partner]) => {
                this.partnerBoolean = partner;
                this.specEigenWoningFormGroup.reset();
                this.berekeningBox1FormGroup.reset();
                if (incomeTaxEntity.aangifte) {
                    const aangifte = incomeTaxEntity.aangifte as Aangifte;
                    this.aangifte = aangifte;
                    this.updateForm()
                    this.disableFormGroup(this.specEigenWoningFormGroup);
                    this.disableFormGroup(this.berekeningBox1FormGroup);
                }
            }
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['aangifteRapport'] || changes['partnerRapport'] || changes['berekening'] || changes['partnerBerekening']) {
            this.updateForm();
        }
    }


    private updateForm() {
        if (this.partnerBoolean) {
            this.specEigenWoning=this.partnerRapport;
            this.specEigenWoningFormGroup.patchValue(this.partnerRapport);
            this.berekeningBox1FormGroup.patchValue(this.partnerBerekening);

        } else {
            this.specEigenWoning=this.aangifteRapport;
            this.specEigenWoningFormGroup.patchValue(this.aangifteRapport);
            this.berekeningBox1FormGroup.patchValue(this.berekening);
        }
    }


    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}



